import { GetStaticProps, GetStaticPaths } from 'next';
import { getStaticPathsCore } from '@/src/getStatic/hnaviCategoryGetStaticPathsCore';
import { getStaticPropsCore } from '@/src/getStatic/hnaviCategoryGetStaticPropsCore';

export { default } from '@/src/pages/[hnaviCategory]/cost/page/[pageNo]';

export const getStaticProps = ({
  params,
}: Parameters<
  GetStaticProps<any, { hnaviCategory: string; pageNo: string }>
>[0]) => getStaticPropsCore({ params, hnaviReferenceKey: 'feature' });
type PathParams = { hnaviCategory: string; pageNo: string };

export const getStaticPaths: GetStaticPaths<PathParams> = () =>
  getStaticPathsCore({ hnaviReferenceKey: 'feature' });
